import { render } from "./ConfirmBooking.vue?vue&type=template&id=d70133b6&scoped=true"
import script from "./ConfirmBooking.vue?vue&type=script&lang=js"
export * from "./ConfirmBooking.vue?vue&type=script&lang=js"

import "./ConfirmBooking.vue?vue&type=style&index=0&id=d70133b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d70133b6"]])

export default __exports__